import React from 'react';
import SafeLink from './SafeLink';

type OwnProps = {
  children: React.ReactNode;
  exact?: boolean;
  matchStyle?: React.CSSProperties;
  path: string;
  toPath?: string;
};

type ComponentProps = OwnProps & React.HTMLAttributes<HTMLAnchorElement>;

const NavLink: React.FC<ComponentProps> = React.forwardRef<
  HTMLAnchorElement,
  ComponentProps
>(
  (
    { toPath, children, exact = false, matchStyle = {}, path, ...restProps },
    ref
  ) => (
    <SafeLink
      {...restProps}
      to={toPath || path}
      ref={ref as any}
      getProps={({ location: { pathname } }) => {
        const isMatch = exact ? pathname === path : pathname.startsWith(path);
        return isMatch ? { style: matchStyle } : {};
      }}
    >
      {children}
    </SafeLink>
  )
);

export default NavLink;
